var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F4C81"
    },
    d: "M410.461,333.102c7.476-61.053-28.744-142.198-66.297-175.706 c-67.793-60.492-124.114-48.794-167.919-27.126c-43.805,21.668-50.063,94.005-80.309,126.734 c-30.246,32.729-47.452,76.751-1.561,120.574c45.891,43.823,82.913,21.555,130.89,18.778 c47.977-2.777,111.598,19.104,146.018,0.077C395.317,383.146,407.157,360.087,410.461,333.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M410.461,333.102c7.476-61.053-28.744-142.198-66.297-175.706 c-67.793-60.492-124.114-48.794-167.919-27.126c-43.805,21.668-50.063,94.005-80.309,126.734 c-30.246,32.729-47.452,76.751-1.561,120.574c45.891,43.823,82.913,21.555,130.89,18.778 c47.977-2.777,111.598,19.104,146.018,0.077C395.317,383.146,407.157,360.087,410.461,333.102z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 220.608,
    y1: 330.952,
    x2: 220.608,
    y2: 106.013
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 74.393,333.177 216.285,333.177 431.852,402.759  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M139.032,327.902h-9.829V165.837h20.23l-8.732-31.51h-26.196l-8.732,31.51h20.229v162.065h-9.829 c-5.241,0-9.493,4.201-9.591,9.418c-0.002,0.024-0.009,0.048-0.009,0.072c0,0.011,0.004,0.021,0.004,0.031 c0,0.026-0.004,0.052-0.004,0.079v0h0.014c0.294,2.26,9.578,4.075,20.996,4.075c11.419,0,20.703-1.815,20.997-4.075h0.052v0 C148.632,332.2,144.334,327.902,139.032,327.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M269.589,94.858 v190.825l143.667,23.636V71.222L269.589,94.858z M409.532,149.498l-73.049,4.137V87.342l73.049-11.624V149.498z M336.483,160.613 l73.049-3.349v66.661l-73.049-3.415V160.613z M330.555,220.232l-58.552-2.737V163.57l58.552-2.685V220.232z M330.555,88.285 v65.686l-58.552,3.316V97.602L330.555,88.285z M272.003,223.778l58.552,3.369v65.109l-58.552-9.317V223.778z M336.483,293.199 v-65.712l73.049,4.203v73.133L336.483,293.199z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#0F4C81"
    },
    cx: 220.037,
    cy: 390.139,
    rx: 114.946,
    ry: 35.814
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    cx: 220.037,
    cy: 390.139,
    rx: 114.946,
    ry: 35.814
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M210.326,232.238c0,0-26.05-3.085-43.188,10.283s-31.877,69.237-31.534,95.972 c0.343,26.735,10.283,40.103,35.304,51.071c25.021,10.968,71.637,6.855,97.686-1.371c26.05-8.226,34.619-37.018,34.276-52.442 c-0.343-15.424-17.481-33.248-23.308-37.018c-5.827-3.77-22.279-11.654-30.506-23.993 C240.831,262.4,228.834,235.665,210.326,232.238z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible",
      fill: "#0F4C81"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000151543286512694195490000006148888041464019351_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.13,
      clipPath: "url(#XMLID_00000151543286512694195490000006148888041464019351_)"
    },
    d: "M273.372,386.372 c-9.85-1.33-21.53-4.003-30.372-9.372c-18.667-11.333-23.333-32.667-30-40.667c-6.667-8-18.667-7.333-24-16 c-5.333-8.667,3.333-72.667-12-76.667c-4.12-1.075-7.222-1.424-9.566-1.365c-0.098,0.075-0.199,0.143-0.296,0.218 c-17.138,13.368-31.877,69.237-31.534,95.973c0.343,26.735,10.283,40.103,35.304,51.071 c25.021,10.968,71.637,6.855,97.686-1.371C270.258,387.668,271.849,387.056,273.372,386.372z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M200.068,244.319c0,0-17,3.25-20,6.25s-15.5,50-15.5,50s5.5-1.5,10.5,0.5s5.5,7.25,6,9.75s0.75,9,0.75,9 s50.534-4.514,61.284-7.014s27.11-3.65,27.11-3.65s-27.644-62.336-31.894-64.586s-22-2.5-24.5-2 S200.068,244.319,200.068,244.319z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 183.318,
    y1: 302.069,
    x2: 187.568,
    y2: 267.319
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 186.568,
    y1: 276.569,
    x2: 192.318,
    y2: 269.069
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M203.818,281.069 c0,0,16.25-5.25,27-5.25"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M219.156,266.736 l-1.088,8.333c0,0,2.75,0,3,1.25s-1,2.5-1,2.5s7.75,4.25,8.75,9.25"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    d: "M209.401,234.986c0,0-9.333,3-10.667,5.333c-1.333,2.333-0.333,18.667-0.333,20.667 s1.167-1.167,2.167-3.5c1-2.333,4.5-5.833,5.667-5.5c1.167,0.333,1.833,1.667,1.833,3.833c0,2.167,2.667,5.167,5,6.833 c2.333,1.667,4.5,3.333,4.5,3.333s4.833-7,6-8.833c1.167-1.833,1-5.667,1.167-7c0.167-1.333,3.167,3.667,3.833,2.333 c0.667-1.333-1.5-2.5-3.833-6.167c-2.333-3.667-1.667-7.5-5.167-10.167C216.068,233.486,212.068,234.319,209.401,234.986z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_14_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000168092809827718308090000000185761904250708667_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_14_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000168092809827718308090000000185761904250708667_)",
      fill: "#0F4C81"
    },
    d: "M198.735,240.319 c-0.89,1.557-0.74,9.344-0.543,14.951c2.125-2.743,6.514-7.915,9.057-6.937c3.237,1.245,4.482,10.458,4.482,10.458 l-2.187-23.84c-0.047,0.012-0.097,0.023-0.143,0.035C209.401,234.986,200.068,237.986,198.735,240.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000168092809827718308090000000185761904250708667_)",
      fill: "#FFFFFF"
    },
    d: " M198.735,240.319c-0.89,1.557-0.74,9.344-0.543,14.951c2.125-2.743,6.514-7.915,9.057-6.937 c3.237,1.245,4.482,10.458,4.482,10.458l-2.187-23.84c-0.047,0.012-0.097,0.023-0.143,0.035 C209.401,234.986,200.068,237.986,198.735,240.319z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_14_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    d: "M187.318,302.569c0,0-5.75-8.25-12.75-9s-15.5,5-15.75,7s-2,12.75-0.75,14.25s6,2.75,15.25-0.25 S186.318,307.819,187.318,302.569z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_15_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000092421977221897293040000013557521593567741337_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000092421977221897293040000013557521593567741337_)",
      fill: "#0F4C81"
    },
    d: "M163.925,314.565 c0,0-1.992-5.727-0.996-7.719c0.996-1.992,4.98-4.98,7.47-7.968c2.49-2.988-5.831,1.691-6.225,0 c-0.317-1.361,4.384-4.075,6.235-5.085c-5.82,1.114-11.39,5.162-11.591,6.776c-0.25,2-2,12.75-0.75,14.25 c0.645,0.774,2.232,1.477,4.881,1.568C163.552,315.335,163.925,314.565,163.925,314.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000092421977221897293040000013557521593567741337_)",
      fill: "#FFFFFF"
    },
    d: " M163.925,314.565c0,0-1.992-5.727-0.996-7.719c0.996-1.992,4.98-4.98,7.47-7.968c2.49-2.988-5.831,1.691-6.225,0 c-0.317-1.361,4.384-4.075,6.235-5.085c-5.82,1.114-11.39,5.162-11.591,6.776c-0.25,2-2,12.75-0.75,14.25 c0.645,0.774,2.232,1.477,4.881,1.568C163.552,315.335,163.925,314.565,163.925,314.565z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_15_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M167.818,304.819c0,0-9.382,3.724-9.75,11c-0.204,4.026,6.5,5.75,13.5,5.75s17-8.75,23.5-12.5 s21.5-12.5,23.25-13.25s7.75,1.25,10.25,2s7.25,0.75,7.25,0.75s3.5,5.5,5.25,5.5s-3.75-8.25-4.5-10s-13-5.75-14.5-5.75 s-36.5,8.75-41.75,10.75S167.818,304.819,167.818,304.819z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_8_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000021113211227926561980000008754264987196784805_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_8_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000021113211227926561980000008754264987196784805_)",
      fill: "#0F4C81"
    },
    d: "M187.425,303.778 c14.296-7.148,34.643-15.459,34.643-15.459c-1.5,0-36.5,8.75-41.75,10.75s-12.5,5.75-12.5,5.75s-9.382,3.724-9.75,11 c-0.204,4.026,6.5,5.75,13.5,5.75s17-8.75,23.5-12.5c1.103-0.636,2.453-1.418,3.939-2.279 C189.456,308.02,176.695,309.143,187.425,303.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000021113211227926561980000008754264987196784805_)",
      fill: "#FFFFFF"
    },
    d: " M187.425,303.778c14.296-7.148,34.643-15.459,34.643-15.459c-1.5,0-36.5,8.75-41.75,10.75s-12.5,5.75-12.5,5.75 s-9.382,3.724-9.75,11c-0.204,4.026,6.5,5.75,13.5,5.75s17-8.75,23.5-12.5c1.103-0.636,2.453-1.418,3.939-2.279 C189.456,308.02,176.695,309.143,187.425,303.778z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_8_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M240.936,249.217l-7.618,42.853l55,0.25l8.181-40.636c0.309-1.533-0.836-2.974-2.398-3.021l-50.602-1.527 C242.246,247.097,241.156,247.983,240.936,249.217z"
  }), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_9_",
    points: "233.318,292.069 206.537,311.011 267.787,309.261 288.318,292.319  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_9_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000085245159178717102110000006746293785658637491_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#XMLID_00000085245159178717102110000006746293785658637491_)",
      fill: "#0F4C81"
    },
    points: " 233.318,292.069 206.537,311.011 267.787,309.261 288.318,292.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000085245159178717102110000006746293785658637491_)",
      fill: "#FFFFFF"
    },
    points: " 233.318,292.069 206.537,311.011 267.787,309.261 288.318,292.319  "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_9_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M253.568,310.819c0,0,22-19.25,43.75-25.75s26.25-5.5,25.75,4.25s-11,60.75-18,73.75 s-15.75,36.75-15.5,41.25s8.75,17.75,16.25,22.5s6.75,10.5,2,11.5s-10.25,2.75-26.5-7.75s-23-25.5-22-29.25 s11.5-8.75,15.75-16.25s11.25-35.5,11.75-48.25s5-23.5,5-23.5s-27.5,5-35.5,10L253.568,310.819z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_12_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000080890358380741810810000001946733538175863198_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_12_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000080890358380741810810000001946733538175863198_)",
      fill: "#0F4C81"
    },
    d: "M253.568,310.819 c0,0,22-19.25,43.75-25.75s26.25-5.5,25.75,4.25s-11,60.75-18,73.75s-15.75,36.75-15.5,41.25s8.75,17.75,16.25,22.5 s6.75,10.5,2,11.5s-10.25,2.75-26.5-7.75s-23-25.5-22-29.25s11.5-8.75,15.75-16.25s11.25-35.5,11.75-48.25s5-23.5,5-23.5 s-27.5,5-35.5,10L253.568,310.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000080890358380741810810000001946733538175863198_)",
      fill: "#FFFFFF"
    },
    d: " M253.568,310.819c0,0,22-19.25,43.75-25.75s26.25-5.5,25.75,4.25s-11,60.75-18,73.75s-15.75,36.75-15.5,41.25 s8.75,17.75,16.25,22.5s6.75,10.5,2,11.5s-10.25,2.75-26.5-7.75s-23-25.5-22-29.25s11.5-8.75,15.75-16.25 s11.25-35.5,11.75-48.25s5-23.5,5-23.5s-27.5,5-35.5,10L253.568,310.819z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_12_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M275.068,385.069c-0.318,0.562-0.681,1.105-1.063,1.639c3.856,0.433,9.421,1.799,14.063,5.861 c1.355,1.186,2.472,2.285,3.419,3.306c2.928-9.345,8.681-23.706,13.581-32.806c7-13,17.5-64,18-73.75s-4-10.75-25.75-4.25 s-43.75,25.75-43.75,25.75l2.75,12.5c8-5,35.5-10,35.5-10s-4.5,10.75-5,23.5S279.318,377.569,275.068,385.069z"
  }), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M275.068,385.069c-0.318,0.562-0.681,1.105-1.063,1.639c3.856,0.433,9.421,1.799,14.063,5.861 c1.355,1.186,2.472,2.285,3.419,3.306c4.793-6.432,10.18-26.75,16.262-35.106c15.715-21.59,14.819-61.7,15.319-71.45 s-4-10.75-25.75-4.25s-43.75,25.75-43.75,25.75l2.75,12.5c8-5,35.5-10,35.5-10s-4.5,10.75-5,23.5 S279.318,377.569,275.068,385.069z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible",
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000180332154478296902670000012686292017466847135_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      clipPath: "url(#XMLID_00000180332154478296902670000012686292017466847135_)",
      fill: "#FFFFFF"
    },
    d: " M275.068,385.069c-0.318,0.562-0.681,1.105-1.063,1.639c3.856,0.433,9.421,1.799,14.063,5.861 c1.355,1.186,2.472,2.285,3.419,3.306c4.793-6.432,10.18-26.75,16.262-35.106c15.715-21.59,14.819-61.7,15.319-71.45 s-4-10.75-25.75-4.25s-43.75,25.75-43.75,25.75l2.75,12.5c8-5,35.5-10,35.5-10s-4.5,10.75-5,23.5 S279.318,377.569,275.068,385.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.14,
      clipPath: "url(#XMLID_00000180332154478296902670000012686292017466847135_)"
    },
    d: "M312.5,288 c-0.395-3.55-39.063,12.815-55.37,19.882c-2.263,1.803-3.562,2.937-3.562,2.937l2.75,12.5c8-5,35.5-10,35.5-10 s-4.5,10.75-5,23.5s-7.5,40.75-11.75,48.25c-0.318,0.562-0.681,1.105-1.063,1.639c2.251,0.253,5.084,0.829,7.975,2.068 c6.056-12.804,12.473-27.648,15.519-39.276C303,328.5,313,292.5,312.5,288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000180332154478296902670000012686292017466847135_)",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M291.818,313.319c0,0,7.5-15.25,14-21.5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M220.608,330.952c0,0,12.339-0.343,23.65-4.456c11.311-4.113-9.255-11.654-17.138-7.541 C219.237,323.069,220.608,330.952,220.608,330.952z"
  }), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    d: "M188.068,314.819c0,0-8,4.5-10.75,9.5s9.083,13.333,21.583,12.833s35.417-14.083,35.417-14.083 s0.25,22,4.5,30s23.75,27.5,31.5,32.5s33.75,23.75,37.75,26.75s11.5,8.5,13.25,8.75s20-22,24.25-29.5s8-23.25,6.5-26.75 s-4.5-0.5-7.5,2s-30.5,20.75-33,22s-4.25,1.75-4.25,1.75s-22.5-21.5-34.5-38s-13-37.75-17.5-45.75c-4.5-8-11-11.5-20.75-10.5 S204.568,302.569,188.068,314.819z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_10_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000064334694174554290200000000882790647415382441_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000064334694174554290200000000882790647415382441_)",
      fill: "#0F4C81"
    },
    d: "M293.853,402.021 c6.676,4.784,12.491,9.005,14.215,10.298c4,3,11.5,8.5,13.25,8.75c0.621,0.089,3.32-2.659,6.731-6.569l-28.631-18.416 L293.853,402.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000064334694174554290200000000882790647415382441_)",
      fill: "#FFFFFF"
    },
    d: " M293.853,402.021c6.676,4.784,12.491,9.005,14.215,10.298c4,3,11.5,8.5,13.25,8.75c0.621,0.089,3.32-2.659,6.731-6.569 l-28.631-18.416L293.853,402.021z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_10_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    d: "M305.766,389.066c-5.287-5.158-25.12-31.768-32.947-47.066c-11.47-22.418-12.705-30.059-17.205-38.059 s-11.296-8.623-21.046-7.623s-27.195,2.81-48.599,14.949c0,0-8.984,4.884-11.734,9.884s7.262,17.59,24.667,16 c12.458-1.138,35.417-14.083,35.417-14.083s0.25,22,4.5,30s23.75,27.5,31.5,32.5c4.915,3.171,17.165,11.868,26.493,18.575 C299.152,395.772,303.284,391.185,305.766,389.066z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1_",
    style: {
      overflow: "visible",
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000090283606790872671750000002088829992496640952_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      clipPath: "url(#XMLID_00000090283606790872671750000002088829992496640952_)",
      fill: "#FFFFFF"
    },
    d: " M305.766,389.066c-5.287-5.158-25.12-31.768-32.947-47.066c-11.47-22.418-12.705-30.059-17.205-38.059 s-11.296-8.623-21.046-7.623s-27.195,2.81-48.599,14.949c0,0-8.984,4.884-11.734,9.884s7.262,17.59,24.667,16 c12.458-1.138,35.417-14.083,35.417-14.083s0.25,22,4.5,30s23.75,27.5,31.5,32.5c4.915,3.171,17.165,11.868,26.493,18.575 C299.152,395.772,303.284,391.185,305.766,389.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.14,
      clipPath: "url(#XMLID_00000090283606790872671750000002088829992496640952_)"
    },
    d: "M255.5,353.5 c-7.5-19-3-57-24-52c-15.303,3.644-43.346,16.578-57.438,23.329c1.664,5.738,10.865,13.601,24.839,12.324 c12.458-1.138,35.417-14.083,35.417-14.083s0.25,22,4.5,30s23.75,27.5,31.5,32.5c4.915,3.171,17.165,11.868,26.493,18.575 c0.947-3.385,2.187-6.142,3.492-8.377C281.683,382.013,259.686,364.106,255.5,353.5z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#XMLID_00000090283606790872671750000002088829992496640952_)",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 234.318,
    y1: 323.069,
    x2: 233.568,
    y2: 310.069
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M308.068,412.319c4,3,11.5,8.5,13.25,8.75s20-22,24.25-29.5s8-23.25,6.5-26.75s-4.5-0.5-7.5,2s-30.5,20.75-33,22 c-0.655,0.327-1.254,0.601-1.788,0.83c-0.724,1.368-1.596,3.494-0.962,4.92c1,2.25,5.25,5.25,5.25,5.25l-7.563,11.345 C307.178,411.658,307.713,412.053,308.068,412.319z"
  }), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M345.568,391.569c4.25-7.5,8-23.25,6.5-26.75c-0.869-2.028-2.243-1.868-3.827-0.894 c1.052,4.678-0.01,13.688-5.173,23.394c-4.607,8.66-18.847,23.966-26.022,31.421c1.947,1.283,3.572,2.229,4.272,2.329 C323.068,421.319,341.318,399.069,345.568,391.569z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_11_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000103232021443087910650000006487506345696492718_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000103232021443087910650000006487506345696492718_)",
      fill: "#0F4C81"
    },
    d: "M321.574,421.004 c0.064-0.029,0.135-0.068,0.213-0.117c0.023-0.015,0.044-0.025,0.068-0.042c0.101-0.067,0.213-0.15,0.335-0.245 c0.038-0.03,0.079-0.065,0.119-0.097c0.092-0.075,0.189-0.157,0.291-0.246c0.054-0.047,0.107-0.093,0.163-0.144 c0.123-0.111,0.253-0.23,0.388-0.358c0.078-0.074,0.16-0.153,0.242-0.232c0.107-0.103,0.215-0.209,0.328-0.321 c0.092-0.092,0.187-0.187,0.283-0.284c0.09-0.091,0.183-0.186,0.276-0.282c0.229-0.236,0.467-0.484,0.715-0.747 c0.038-0.041,0.075-0.079,0.114-0.12c0.145-0.155,0.296-0.317,0.447-0.481c0.058-0.063,0.117-0.126,0.176-0.191 c0.523-0.569,1.077-1.185,1.656-1.841c0.015-0.017,0.03-0.034,0.045-0.051c0.202-0.229,0.406-0.462,0.614-0.699 c0.001-0.001,0.002-0.003,0.003-0.004l-4.365-2.808c-2.489,2.701-4.798,5.135-6.638,7.048c0,0,0,0,0,0 c0.231,0.152,0.457,0.299,0.677,0.441c0.032,0.02,0.062,0.04,0.094,0.06c0.211,0.135,0.418,0.266,0.618,0.39 c0.004,0.003,0.008,0.005,0.012,0.008c0.342,0.212,0.659,0.399,0.96,0.571c0.094,0.053,0.19,0.11,0.279,0.159 c0.098,0.054,0.188,0.101,0.28,0.149c0.11,0.058,0.217,0.113,0.318,0.163c0.076,0.037,0.148,0.072,0.219,0.104 c0.109,0.05,0.21,0.092,0.305,0.129c0.051,0.02,0.104,0.042,0.151,0.059c0.135,0.047,0.259,0.083,0.359,0.097 c0.049,0.007,0.115-0.01,0.189-0.037C321.528,421.025,321.551,421.014,321.574,421.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000103232021443087910650000006487506345696492718_)",
      fill: "#FFFFFF"
    },
    d: " M321.574,421.004c0.064-0.029,0.135-0.068,0.213-0.117c0.023-0.015,0.044-0.025,0.068-0.042c0.101-0.067,0.213-0.15,0.335-0.245 c0.038-0.03,0.079-0.065,0.119-0.097c0.092-0.075,0.189-0.157,0.291-0.246c0.054-0.047,0.107-0.093,0.163-0.144 c0.123-0.111,0.253-0.23,0.388-0.358c0.078-0.074,0.16-0.153,0.242-0.232c0.107-0.103,0.215-0.209,0.328-0.321 c0.092-0.092,0.187-0.187,0.283-0.284c0.09-0.091,0.183-0.186,0.276-0.282c0.229-0.236,0.467-0.484,0.715-0.747 c0.038-0.041,0.075-0.079,0.114-0.12c0.145-0.155,0.296-0.317,0.447-0.481c0.058-0.063,0.117-0.126,0.176-0.191 c0.523-0.569,1.077-1.185,1.656-1.841c0.015-0.017,0.03-0.034,0.045-0.051c0.202-0.229,0.406-0.462,0.614-0.699 c0.001-0.001,0.002-0.003,0.003-0.004l-4.365-2.808c-2.489,2.701-4.798,5.135-6.638,7.048c0,0,0,0,0,0 c0.231,0.152,0.457,0.299,0.677,0.441c0.032,0.02,0.062,0.04,0.094,0.06c0.211,0.135,0.418,0.266,0.618,0.39 c0.004,0.003,0.008,0.005,0.012,0.008c0.342,0.212,0.659,0.399,0.96,0.571c0.094,0.053,0.19,0.11,0.279,0.159 c0.098,0.054,0.188,0.101,0.28,0.149c0.11,0.058,0.217,0.113,0.318,0.163c0.076,0.037,0.148,0.072,0.219,0.104 c0.109,0.05,0.21,0.092,0.305,0.129c0.051,0.02,0.104,0.042,0.151,0.059c0.135,0.047,0.259,0.083,0.359,0.097 c0.049,0.007,0.115-0.01,0.189-0.037C321.528,421.025,321.551,421.014,321.574,421.004z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_11_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M305.818,426.819c-7.5-4.75-16-18-16.25-22.5c-0.02-0.366,0.025-0.87,0.117-1.474c-2.375,0.029-4.117,1.474-4.117,1.474 s-5.5-5-9.75-7.75c-3.045-1.97-6.976-2.526-8.968-2.685c-3.631,2.981-6.988,5.395-7.532,7.435c-1,3.75,5.75,18.75,22,29.25 s21.75,8.75,26.5,7.75S313.318,431.569,305.818,426.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M257.818,401.819"
  }), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    d: "M305.818,426.819c-2.214-1.402-4.512-3.554-6.663-5.994c-5.16-2.191-12.044-5.037-18.087-8.756 c-6.5-4-5-6.5-8.75-10.25c-2.878-2.878-8.539-3.251-11.024-3.27c-1.025,0.998-1.749,1.917-1.976,2.77 c-1,3.75,5.75,18.75,22,29.25s21.75,8.75,26.5,7.75S313.318,431.569,305.818,426.819z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_13_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000065759959604567738430000002963726498383915420_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000065759959604567738430000002963726498383915420_)",
      fill: "#0F4C81"
    },
    d: "M305.818,426.819 c-2.214-1.402-4.512-3.554-6.663-5.994c-5.16-2.191-12.044-5.037-18.087-8.756c-6.5-4-5-6.5-8.75-10.25 c-2.878-2.878-8.539-3.251-11.024-3.27c-1.025,0.998-1.749,1.917-1.976,2.77c-1,3.75,5.75,18.75,22,29.25s21.75,8.75,26.5,7.75 S313.318,431.569,305.818,426.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000065759959604567738430000002963726498383915420_)",
      fill: "#FFFFFF"
    },
    d: " M305.818,426.819c-2.214-1.402-4.512-3.554-6.663-5.994c-5.16-2.191-12.044-5.037-18.087-8.756c-6.5-4-5-6.5-8.75-10.25 c-2.878-2.878-8.539-3.251-11.024-3.27c-1.025,0.998-1.749,1.917-1.976,2.77c-1,3.75,5.75,18.75,22,29.25s21.75,8.75,26.5,7.75 S313.318,431.569,305.818,426.819z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_13_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M307.068,428.569c-6.5-3.75-19.75-6.25-28.25-12s-6.25-10.75-12.5-14.75 c-2.872-1.838-5.266-1.405-7.018-0.401c-0.868,3.898,5.899,18.736,22.018,29.151c16.25,10.5,21.75,8.75,26.5,7.75 c3.157-0.665,4.529-3.43,2.904-6.604C309.696,430.483,308.483,429.386,307.068,428.569z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_3_",
    style: {
      overflow: "visible",
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000057137269125456839980000008807028832670175371_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      clipPath: "url(#XMLID_00000057137269125456839980000008807028832670175371_)",
      fill: "#FFFFFF"
    },
    d: " M307.068,428.569c-6.5-3.75-19.75-6.25-28.25-12s-6.25-10.75-12.5-14.75c-2.872-1.838-5.266-1.405-7.018-0.401 c-0.868,3.898,5.899,18.736,22.018,29.151c16.25,10.5,21.75,8.75,26.5,7.75c3.157-0.665,4.529-3.43,2.904-6.604 C309.696,430.483,308.483,429.386,307.068,428.569z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_3_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M182.491,380.749c0,0,4.799-5.827,5.484-1.371c0.686,4.456-0.343,12.682-3.77,15.767c-3.428,3.085-5.141-1.714-5.141-1.714 l2.056-2.742c0,0,1.714,3.428,3.085-2.057c1.371-5.484-2.742-4.799-2.742-4.799L182.491,380.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M178.817,402.685c-2.84,2.102-12.092,2.102-14.932,0c-6.01-4.449-4.977-25.945-4.977-25.945h24.864 C183.772,376.74,184.827,398.236,178.817,402.685z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M161.61,372.523 c0-2.707,2.506-2.707,2.506-5.414c0-2.705-2.506-2.705-2.506-5.411c0-2.708,2.506-2.708,2.506-5.415 c0-2.71-2.506-2.71-2.506-5.419c0-2.71,2.506-2.71,2.506-5.419"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M170.2,372.523 c0-2.055,2.506-2.055,2.506-4.109c0-2.055-2.506-2.055-2.506-4.11c0-2.057,2.506-2.057,2.506-4.114 c0-2.058-2.506-2.058-2.506-4.116c0-2.058,2.506-2.058,2.506-4.116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M179.648,372.523 c0-2.707,2.506-2.707,2.506-5.414c0-2.705-2.506-2.705-2.506-5.411c0-2.708,2.506-2.708,2.506-5.415 c0-2.71-2.506-2.71-2.506-5.419c0-2.71,2.506-2.71,2.506-5.419"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M183.772,376.74c0,0.626-5.566,1.133-12.432,1.133s-12.432-0.507-12.432-1.133c0-0.625,5.566-1.132,12.432-1.132 S183.772,376.115,183.772,376.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M206.721,222.024c0,0,1.164,12.631,1.655,16.614c0.49,3.984,1.609,15.449,2.759,19.24 c1.15,3.791,7.414,10.383,8.021,8.858c0.607-1.525,3.705-11.822,2.463-17.944c-1.242-6.123-1.618-11.445-0.844-12.977 s3.539-3.308,3.539-3.308s-4.935-2.475-9.389-5.468C210.47,224.045,207.335,220.665,206.721,222.024z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_5_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000092441977059915755200000014405016916609194391_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000092441977059915755200000014405016916609194391_)",
      fill: "#0F4C81"
    },
    d: "M222.768,233.093 l-1.022-1.946c-1.836-1.007-4.397-2.478-6.821-4.108c-4.454-2.994-7.59-6.373-8.203-5.015c0,0,1.164,12.631,1.655,16.614 c0.49,3.984,1.609,15.449,2.759,19.24c0.281,0.925,0.869,2.018,1.602,3.118c-1.21-7.541,0.103-21.153,0.103-21.153 L222.768,233.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000092441977059915755200000014405016916609194391_)",
      fill: "#FFFFFF"
    },
    d: " M222.768,233.093l-1.022-1.946c-1.836-1.007-4.397-2.478-6.821-4.108c-4.454-2.994-7.59-6.373-8.203-5.015 c0,0,1.164,12.631,1.655,16.614c0.49,3.984,1.609,15.449,2.759,19.24c0.281,0.925,0.869,2.018,1.602,3.118 c-1.21-7.541,0.103-21.153,0.103-21.153L222.768,233.093z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_5_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    d: "M206.255,223.827c0,0,7.201,6.028,12.728,8.204c5.526,2.176,14.01,2.06,15.202-0.816 c1.193-2.876-2.096-25.598-4.943-31.579s-5.898-6.079-10.921-6.534c-5.023-0.455-15.091,3.641-16.858,8.498 c-1.767,4.857,0.245,11.742,1.711,15.82C204.64,221.497,206.255,223.827,206.255,223.827z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_6_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000080169450078879962070000010730531769101941120_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_6_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000080169450078879962070000010730531769101941120_)",
      fill: "#0F4C81"
    },
    d: "M219.194,223.562 c-2.552-7.584-3.177-19.458-3.177-22.635c0-2.451,6.38-5.137,9.296-6.237c-1.909-1.182-4.129-1.329-6.991-1.588 c-5.023-0.455-15.091,3.641-16.858,8.498c-1.767,4.857,0.245,11.742,1.711,15.82c1.466,4.077,3.081,6.408,3.081,6.408 s7.201,6.028,12.728,8.204c3.682,1.45,8.666,1.876,11.942,1.152C227.021,231.691,220.894,228.614,219.194,223.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000080169450078879962070000010730531769101941120_)",
      fill: "#FFFFFF"
    },
    d: " M219.194,223.562c-2.552-7.584-3.177-19.458-3.177-22.635c0-2.451,6.38-5.137,9.296-6.237 c-1.909-1.182-4.129-1.329-6.991-1.588c-5.023-0.455-15.091,3.641-16.858,8.498c-1.767,4.857,0.245,11.742,1.711,15.82 c1.466,4.077,3.081,6.408,3.081,6.408s7.201,6.028,12.728,8.204c3.682,1.45,8.666,1.876,11.942,1.152 C227.021,231.691,220.894,228.614,219.194,223.562z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_6_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M229.784,208.973c0.113,2.88-1.692,5.29-4.032,5.382c-2.34,0.092-4.329-2.168-4.443-5.048c-0.113-2.88,1.692-5.29,4.032-5.382 C227.681,203.832,229.67,206.092,229.784,208.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M235.443,207.879c0.113,2.88-0.816,5.255-2.076,5.305c-1.26,0.05-2.373-2.245-2.487-5.125 c-0.113-2.88,0.816-5.255,2.076-5.305C234.216,202.705,235.33,204.999,235.443,207.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M230.077,207.936c0,0,8.26,1.571,7.468,3.561c-0.792,1.99-6.382,4.14-6.382,4.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M229.571,207.017c0,0,0.116-1.021,1.393-0.368"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 221.076,
    y1: 209.776,
    x2: 206.056,
    y2: 215.686
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M221.276,204.919c0,0,0.923-2.383,3.744-2.259"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 231.279,
    y1: 202.726,
    x2: 228.967,
    y2: 203.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M224.136,219.504c0,0,2.972-0.784,4.709,0.982"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M226.075,209.522c0.137,1.003-0.047,1.857-0.412,1.907c-0.365,0.05-0.772-0.723-0.909-1.726 c-0.137-1.003,0.047-1.857,0.412-1.907C225.531,207.746,225.938,208.519,226.075,209.522z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M207.46,215.727c0,0-1.01,1.998,1.824,2.104c2.833,0.106,4.738-1.275,3.365-2.962c-1.372-1.687-3.396-3.348-1.309-5.607 c2.088-2.258,6.148-4.159,3.872-6.681c-2.276-2.522-10.673-0.233-8.577-2.274c2.096-2.041,11.806-4.164,16.169-3.901 c4.363,0.264,12.501-3.104,14.285-7.526c1.785-4.423-0.713-12.594-6.572-12.146c-5.858,0.448-10.225,5.626-12.824,5.945 c-2.599,0.32-7.934-2.517-12.403,0.053c-4.469,2.57-4.621,9.758-5.022,10.644c-0.4,0.886-6.442,2.212-7.506,8.348 c-1.064,6.136,1.74,11.031,4.241,13.761c2.501,2.731,3.631,3.775,3.631,3.775L207.46,215.727z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M194.736,204.651c-0.099,1.516,0.646,2.659,0.646,2.659"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M220.233,188.821c0,0-2.187-4.771,3.38-4.771c5.567,0,6.362,6.958,0.596,9.543c-5.765,2.584-18.29,3.181-25.05,6.163 c-1.69,0.746-2.771,1.59-3.442,2.439"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M210.165,205.761c-1.998,0.715-4.591,1.716-7.229,2.941c-5.567,2.585-4.374,5.169-4.374,5.169"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M213.871,204.527c0,0-0.486,0.144-1.317,0.416"
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    d: "M208.415,217.866c0,0-3.23-4.661-6.639-2.786c-3.408,1.875-0.753,8.517,1.297,10.83 c2.05,2.313,6.016-1.978,6.408-3.081"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_7_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000030444827557881775010000010954682308312972201_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000030444827557881775010000010954682308312972201_)",
      fill: "#0F4C81"
    },
    d: "M208.415,217.866 c0,0-3.23-4.661-6.639-2.786c-3.408,1.875-0.753,8.517,1.297,10.83c2.05,2.313,6.016-1.978,6.408-3.081"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000030444827557881775010000010954682308312972201_)",
      fill: "#FFFFFF"
    },
    d: " M208.415,217.866c0,0-3.23-4.661-6.639-2.786c-3.408,1.875-0.753,8.517,1.297,10.83c2.05,2.313,6.016-1.978,6.408-3.081"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_7_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M167.617,276.258H95.939c-2.828,0-5.12-2.292-5.12-5.12v-52.403c0-2.828,2.292-5.12,5.12-5.12h71.678 c2.828,0,5.12,2.292,5.12,5.12v52.403C172.737,273.966,170.444,276.258,167.617,276.258z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 171.177,258.679 219.177,271.179 171.177,247.679  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.445,
    y: 219.639,
    style: {
      fill: "#0F4C81",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.275,
    height: 50.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.076,
    y: 219.639,
    style: {
      fill: "#0F4C81",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 2.409,
    height: 50.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.076,
    y: 242.775,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 2.409,
    height: 4.324
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 122.743,
    y1: 220.843,
    x2: 160.69,
    y2: 220.843
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 122.743,
    y1: 226.264,
    x2: 160.69,
    y2: 226.264
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 122.743,
    y1: 231.685,
    x2: 160.69,
    y2: 231.685
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 122.743,
    y1: 237.106,
    x2: 160.69,
    y2: 237.106
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 122.743,
    y1: 250.358,
    x2: 160.69,
    y2: 250.358
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 122.743,
    y1: 255.176,
    x2: 160.69,
    y2: 255.176
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 122.743,
    y1: 259.995,
    x2: 160.69,
    y2: 259.995
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 122.743,
    y1: 269.995,
    x2: 160.69,
    y2: 269.995
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 97.445,
    y1: 270.235,
    x2: 116.719,
    y2: 219.639
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#0F4C81"
    },
    cx: 387.865,
    cy: 402.759,
    rx: 16.726,
    ry: 7.504
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    cx: 387.865,
    cy: 402.759,
    rx: 16.726,
    ry: 7.504
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M368.296,291.777c1.79,0.782,6.169,0.684,6.172,0.683c0.046-0.001-0.941-2.867-1.024-3.04 c-0.961-2.01-3.999-5.328-6.471-4.994c-1.781,0.241-2.771,2.023-2.369,3.7C365.015,289.839,366.772,291.111,368.296,291.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M425.656,276.872c-2.48-0.267-5.428,3.132-6.334,5.167c-0.078,0.176-0.987,3.067-0.941,3.067 c0,0,0.043,0,0.053-0.001c-0.47,0.533-0.967,1.11-1.497,1.751c-0.97,1.192-2.056,2.548-3.137,4.103 c-1.085,1.551-2.22,3.267-3.253,5.182c-1.038,1.919-2.031,3.989-2.779,6.256c-0.009,0.025-0.014,0.053-0.022,0.079 c0.013-0.731-0.019-2.775-0.04-2.932c-0.286-2.209-2.138-6.31-4.591-6.763c-1.767-0.326-3.264,1.058-3.405,2.777 c-0.143,1.755,1.129,3.512,2.37,4.621c1.399,1.25,5.284,2.461,5.594,2.556c-0.692,2.165-1.227,4.442-1.641,6.777 c-0.238,1.335-0.437,2.686-0.618,4.044c-0.009-0.632-0.022-1.197-0.033-1.276c-0.287-2.209-2.138-6.309-4.591-6.763 c-1.768-0.327-3.264,1.058-3.405,2.777c-0.144,1.755,1.129,3.512,2.37,4.62c1.259,1.125,4.55,2.223,5.425,2.503 c-0.064,0.521-0.134,1.042-0.196,1.563c-0.299,2.503-0.587,5.003-0.944,7.446c-0.125,0.861-0.281,1.704-0.433,2.549 c-0.009-0.561-0.021-1.034-0.03-1.106c-0.286-2.209-2.138-6.31-4.591-6.763c-1.767-0.327-3.264,1.058-3.405,2.777 c-0.144,1.755,1.129,3.512,2.37,4.62c1.201,1.073,4.23,2.115,5.268,2.451c-0.182,0.86-0.363,1.722-0.578,2.547 c-0.16,0.56-0.274,1.11-0.466,1.664c-0.178,0.552-0.355,1.099-0.529,1.64c-0.375,1.03-0.755,2.095-1.146,3.091 c-0.266,0.694-0.534,1.351-0.8,2.014c0.135-0.855,0.364-2.536,0.367-2.679c0.034-1.48-0.491-3.885-1.537-5.577 c0.006-0.219-0.006-0.437-0.041-0.653c-0.273-1.703-1.873-2.967-3.61-2.505c-2.411,0.642-3.94,4.873-4.054,7.098 c-0.007,0.131,0.079,1.563,0.148,2.466c-0.121-0.525-0.233-1.035-0.365-1.573c-0.253-1.066-0.537-2.123-0.838-3.261 c-0.164-0.544-0.331-1.094-0.499-1.649c-0.155-0.554-0.389-1.12-0.582-1.686c-0.477-1.303-1.023-2.602-1.603-3.897 c0.933-0.224,4.235-1.066,5.561-2.083c1.32-1.013,2.72-2.67,2.707-4.431c-0.012-1.724-1.401-3.217-3.188-3.023 c-2.48,0.269-4.633,4.22-5.083,6.402c-0.028,0.136-0.175,1.738-0.239,2.619c-0.355-0.776-0.705-1.552-1.089-2.325 c-1.108-2.233-2.3-4.458-3.479-6.683c-0.362-0.682-0.713-1.365-1.069-2.047c0.333-0.076,4.28-0.992,5.765-2.131 c1.32-1.013,2.72-2.67,2.708-4.431c-0.012-1.724-1.402-3.216-3.189-3.022c-2.48,0.269-4.632,4.22-5.083,6.402 c-0.034,0.164-0.242,2.47-0.266,3.058c-0.781-1.504-1.546-3.009-2.239-4.525c-0.96-2.089-1.786-4.192-2.435-6.288 c0.155-0.035,4.278-0.972,5.8-2.139c1.32-1.013,2.72-2.67,2.707-4.431c-0.012-1.724-1.402-3.216-3.188-3.022 c-2.48,0.269-4.633,4.22-5.083,6.402c-0.035,0.172-0.258,2.651-0.266,3.104c-0.038-0.125-0.092-0.25-0.129-0.375 c-0.665-2.247-1.027-4.507-1.262-6.64c-0.139-1.239-0.203-2.431-0.239-3.592c0.786-0.096,4.373-0.573,5.858-1.472 c1.423-0.862,2.997-2.355,3.178-4.107c0.177-1.715-1.04-3.351-2.837-3.354c-2.495-0.005-5.068,3.686-5.755,5.805 c-0.037,0.115-0.287,1.329-0.457,2.215c-0.008-0.524-0.026-1.065-0.024-1.568c0.004-1.886,0.123-3.614,0.241-5.143 c0.074-0.869,0.158-1.653,0.245-2.386c0.722-0.497,3.607-2.533,4.495-3.989c0.866-1.421,1.574-3.471,0.928-5.109 c-0.633-1.604-2.467-2.495-4.064-1.67c-2.216,1.146-2.799,5.607-2.433,7.804c0.032,0.19,0.869,3.103,0.907,3.077 c0,0,0.035-0.024,0.044-0.03c-0.097,0.704-0.194,1.459-0.282,2.286c-0.152,1.529-0.309,3.259-0.353,5.153 c-0.049,1.892-0.05,3.95,0.146,6.117c0.193,2.172,0.507,4.448,1.133,6.75c0.007,0.026,0.018,0.052,0.025,0.078 c-0.392-0.616-1.547-2.304-1.651-2.423c-1.457-1.685-5.264-4.083-7.56-3.108c-1.654,0.703-2.139,2.683-1.308,4.195 c0.849,1.543,2.879,2.306,4.526,2.546c1.857,0.271,5.765-0.862,6.075-0.954c0.617,2.188,1.428,4.382,2.37,6.558 c0.537,1.245,1.118,2.482,1.715,3.714c-0.356-0.522-0.679-0.986-0.731-1.047c-1.458-1.685-5.264-4.083-7.56-3.108 c-1.655,0.702-2.139,2.683-1.308,4.194c0.848,1.543,2.879,2.307,4.526,2.546c1.671,0.243,5.022-0.656,5.905-0.906 c0.234,0.47,0.463,0.943,0.698,1.412c1.132,2.253,2.271,4.497,3.32,6.732c0.37,0.788,0.706,1.576,1.045,2.365 c-0.317-0.464-0.588-0.851-0.635-0.906c-1.458-1.685-5.264-4.083-7.56-3.108c-1.654,0.703-2.139,2.683-1.308,4.194 c0.848,1.543,2.879,2.306,4.525,2.546c1.594,0.232,4.695-0.57,5.746-0.862c0.322,0.818,0.647,1.636,0.923,2.443 c0.176,0.555,0.384,1.078,0.529,1.645c0.156,0.559,0.31,1.112,0.463,1.66c0.256,1.066,0.526,2.164,0.749,3.21 c0.161,0.726,0.301,1.422,0.443,2.121c-0.359-0.788-1.096-2.316-1.172-2.437c-1.185-1.886-4.585-4.833-7.002-4.217 c-1.741,0.444-2.521,2.328-1.928,3.948c0.605,1.654,2.496,2.716,4.087,3.203c1.752,0.535,5.631,0.046,6.115-0.018 c0.233,1.159,0.448,2.288,0.633,3.357c0.653,3.704,1.056,6.815,1.308,8.992c0.045,0.387,0.083,0.732,0.117,1.058h-7.507 l2.414,47.103c0.184,3.58,3.139,6.388,6.724,6.388l0,0c3.585,0,6.541-2.808,6.724-6.388l2.414-47.103h-6.995 c0.052-0.108,0.101-0.208,0.155-0.321c0.96-1.999,2.291-4.873,3.728-8.389c0.457-1.11,0.923-2.305,1.39-3.537 c0.469,0.098,4.309,0.878,6.098,0.474c1.623-0.367,3.588-1.285,4.315-2.889c0.711-1.571,0.075-3.508-1.629-4.08 c-2.364-0.794-5.974,1.891-7.297,3.684c-0.078,0.106-0.797,1.348-1.237,2.138c0.188-0.504,0.376-0.992,0.564-1.513 c0.377-1.029,0.724-2.066,1.1-3.182c0.163-0.545,0.328-1.095,0.494-1.651c0.177-0.548,0.294-1.149,0.445-1.728 c0.321-1.35,0.582-2.734,0.813-4.134c0.902,0.328,4.12,1.448,5.788,1.331c1.659-0.117,3.741-0.726,4.702-2.202 c0.941-1.445,0.605-3.456-0.992-4.28c-2.217-1.143-6.192,0.965-7.771,2.536c-0.098,0.098-1.105,1.353-1.644,2.053 c0.133-0.843,0.269-1.683,0.375-2.54c0.307-2.473,0.541-4.987,0.785-7.493c0.074-0.768,0.158-1.532,0.238-2.297 c0.319,0.12,4.116,1.534,5.984,1.403c1.66-0.116,3.742-0.726,4.703-2.202c0.941-1.445,0.605-3.456-0.992-4.28 c-2.217-1.144-6.192,0.964-7.771,2.536c-0.119,0.118-1.564,1.926-1.909,2.404c0.178-1.685,0.371-3.363,0.629-5.009 c0.352-2.272,0.823-4.482,1.438-6.588c0.149,0.056,4.105,1.549,6.018,1.415c1.66-0.116,3.742-0.726,4.703-2.202 c0.941-1.445,0.605-3.456-0.992-4.28c-2.217-1.144-6.192,0.964-7.771,2.536c-0.124,0.123-1.678,2.069-1.934,2.442 c0.037-0.125,0.061-0.259,0.1-0.383c0.685-2.241,1.63-4.326,2.61-6.234c0.567-1.11,1.172-2.139,1.783-3.128 c0.708,0.354,3.963,1.934,5.698,2.003c1.663,0.067,3.799-0.311,4.916-1.672c1.094-1.333,0.981-3.369-0.516-4.363 c-2.078-1.38-6.26,0.279-8.002,1.667c-0.095,0.075-0.973,0.95-1.603,1.595c0.282-0.442,0.565-0.903,0.845-1.321 c1.043-1.572,2.096-2.946,3.038-4.156c0.541-0.684,1.044-1.291,1.521-1.855c0.876-0.016,4.406-0.123,5.949-0.847 c1.506-0.707,3.228-2.027,3.592-3.749C428.482,278.82,427.443,277.065,425.656,276.872z M398.193,343.512 c-1.499,3.45-2.879,6.267-3.87,8.221c-0.2,0.394-0.38,0.742-0.546,1.064h-0.166c-0.049-0.382-0.103-0.799-0.168-1.267 c-0.303-2.197-0.778-5.328-1.519-9.054c-0.231-1.178-0.502-2.431-0.792-3.716c0.291-0.116,1.946-0.785,3.411-1.604 c1.277,1.383,4.549,3.001,4.972,3.207C399.072,341.457,398.628,342.518,398.193,343.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M412.587,292.74c0.039,0.024,0.796-2.91,0.823-3.101c0.307-2.207-0.396-6.65-2.642-7.735 c-1.618-0.782-3.427,0.158-4.017,1.779c-0.602,1.655,0.161,3.685,1.066,5.082C408.877,290.405,412.584,292.738,412.587,292.74z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImg);
export default __webpack_public_path__ + "static/media/hero-img.f0c4bb9704112a308cc6755202fa26f4.svg";
export { ForwardRef as ReactComponent };